import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import termsService from 'v2/services/termsConditions';

export function useSaveTerms(options: UseMutationOptions<void, unknown, boolean> = {}) {
  return useMutation({
    mutationFn: async (accepted: boolean) => termsService.saveTermsResponse(accepted),
    ...options
  });
}
